import React from 'react';

import { Flex } from 'common/components/Flex';
import { BodyRegularBR2, HeadlineH8 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';

interface ChannelLabelProps {
  label: string;
  description: string;
}

const ChannelLabel = ({ label, description }: ChannelLabelProps) => {
  const { t } = useLocalization();

  return (
    <Flex flexDirection="column">
      <HeadlineH8 mb="sp_4">{t(label)}</HeadlineH8>
      <BodyRegularBR2>{t(description)}</BodyRegularBR2>
    </Flex>
  );
};

export default ChannelLabel;
